import React, { useContext, useState } from 'react';
import { SubscribeStyled } from './styles';
import { validateEmail } from '../../helpers/functions';
import { ContentContext } from '../../../context/ContentContext';
import { Snackbar, Alert } from '@mui/material';
import { CircularProgress } from '@mui/material';

const BoxRegistro = (props) => {

    const { handleGotoRegistro } = props;
    
    return (
        <SubscribeStyled>
            <div className='inner'>
                <div className='title'>
                    <div className='suscribite'>REGISTRATE</div>
                </div>
                <div className='bajada'>Y participá durante tu vista al MERCADO RURAL completando las experiencias de los diferentes espacios para participar del Sorteo Experiencia en campo.</div>
                <div className='actions'>
                    <div className='bt_subscribe' onClick={handleGotoRegistro}>
                        Registrame
                    </div>
                </div>
            </div>
            <div className="image">
                <img src={`/images/bienvenidos3.jpg`} />
            </div>
        </SubscribeStyled>
    );
};

export default BoxRegistro;